import React, { useMemo } from 'react';
import PlayerLeaderCardFigure from "../PlayerLeaderCardFigure";
import PlayerLeaderCardBody from "../PlayerLeaderCardBody";
import { cardTypes } from "../../../shared/utils";
import ErrorDisplay from "../../../shared/components/ErrorDisplay";
import LeaderCardLoading from "../LeaderCardLoading/LeaderCardLoading";
import { useLeaderCard } from "../../utils";
import { useReactAppState } from "../../../shared/containers/utils";
import useForgeClubs from '../../../mls-standings/hooks/useForgeClubs';

function PlayerLeaderData() {
  const { t } = useReactAppState();
  const {
    first,
    rest,
    currentStatType,
    advertiser,
    statTableUrl
  } = useLeaderCard();
  const allPlayers = [first, ...rest]

  const clubIds = useMemo(() => allPlayers?.map(({ team_id }) => ({ club_id: team_id })), [allPlayers]);

  const { data: clubsData, isLoading: isClubsLoading, isError: isClubsError } = useForgeClubs({ clubs: clubIds });

  const playersWithClubs = useMemo(() => {
    return allPlayers.map(player => {
      const club = clubsData?.find(club => club?.sportecId == player?.team_id);
      return {
        ...player,
        club
      };
    });
  }, [allPlayers, clubsData]);

  const [firstPlayer, ...restPlayers] = playersWithClubs;

  return (
    isClubsLoading
      ? <LeaderCardLoading cardType={cardTypes.player} statTableUrl={statTableUrl} advertiser={advertiser} currentStatViewType={t(currentStatType.key)} />
      : isClubsError
        ? <ErrorDisplay error={isClubsError} />
        : (
          firstPlayer ? (
            <>
              <PlayerLeaderCardFigure playerData={firstPlayer} clubData={firstPlayer?.club} />
              <PlayerLeaderCardBody first={firstPlayer} rest={restPlayers} clubData={firstPlayer?.club} />
            </>
          )
            : null
        )
  );
}

// eslint-disable-next-line no-func-assign
PlayerLeaderData = React.memo(PlayerLeaderData);

export default PlayerLeaderData;
